import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useBibleStore } from '../../store/bibleStore';
import logo from '../../assets/logo (15).png';

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

export function Header({ sidebarOpen, setSidebarOpen }: HeaderProps) {
  return (
    <header className="h-20 lg:h-16 bg-obsidian-900/95 backdrop-blur-lg border-b border-white/10 shadow-lg">
      <div className="h-full max-w-[100rem] mx-auto px-4 sm:px-6 flex items-center">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors flex-shrink-0"
            aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
          >
            {sidebarOpen ? (
              <X size={24} className="text-white/60" />
            ) : (
              <Menu size={24} className="text-white/60" />
            )}
          </button>
          
          <Link to="/" className="flex items-center gap-3 min-w-0">
            <img 
              src={logo} 
              alt="Divine Intelligence" 
              className="h-12 w-12 object-contain rounded-full"
            />
            <h1 className="text-lg sm:text-xl md:text-2xl font-semibold bg-gradient-to-r from-gold-500 to-gold-300 bg-clip-text text-transparent whitespace-nowrap">
              Divine Intelligence
            </h1>
          </Link>
        </div>
      </div>
    </header>
  );
}
